import Vue from 'vue';
import axios from 'axios';
import config from '@/common/config';
import help from '@/common/help';
import {
  Toast
} from 'vant';
import {
  router
}
from '@/router/index';
import md5 from 'blueimp-md5';

var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

const generateMixed = (n) => {
  var res = '';
  for (var i = 0; i < n; i++) {
    var id = Math.ceil(Math.random() * 35);
    res += chars[id];
  }
  return res;
};

const baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

const headers = {

};
// axios实例
export const instance = axios.create({
  baseURL,
  headers,
  timeout: 60000
});
/**
 * 请求数据拦截
 */
// var baseURL = Vue.prototype.baseURL ? Vue.prototype.baseURL : config.baseUrl.dev

instance.interceptors.request.use(
  config => {
    if (config.loading) {
      Toast.loading({
        message: '',
        duration: 0,
        forbidClick: true
      });
    }
    // async (config) => {
    //     if (process.env.NODE_ENV === 'production' && !Vue.prototype.baseURL) {
    //       await axios.get('./config.json').then(e => {
    //         baseURL = e.data.baseURL
    //       })
    //     }
    //     Vue.prototype.baseURL = baseURL
    //     config.baseURL = baseURL

    config.headers = {
      timestamp: parseInt(new Date().getTime() / 1000),
      version: '1.0.0',
      platform: 'WEIXIN',
      nonce: generateMixed(5)
    };
    if (help.getToken()) {
      config.headers['token'] = help.getToken();
    }
    const arr = [];
    Object.getOwnPropertyNames(config.headers).forEach((key) => {
      if (config.headers[key] == '[object Object]') {
        return;
      }
      arr.push(key + '=' + config.headers[key]);
    });
    config.headers['sign'] = md5(arr.sort().join('&') + '&secret=' + help.getSecret()).toLowerCase();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
/**
 * 响应数据拦截
 */

instance.interceptors.response.use(
  response => {
    Toast.clear();
    const res = response.data;
    if (res.code !== 200) {
      Toast.clear();
      if (res.code === 203) {
        help.delToken();
        location.reload();
      }
      if (res.code !== 203) {
        Toast.fail({
          icon: 'warning',
          message: res.message,
          mask: true,
          className: 'newToast'
        });
      }
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res;
    }
  },
  error => {
    // Toast.fail({
    //   icon: 'warning',
    //   message: '网络错误',
    //   mask: true,
    //   className: 'newToast'
    // });
    return Promise.reject(error);
  }
);

export const instanceNoErr = axios.create({
  baseURL,
  headers,
  timeout: 10000
});
/**
 * 请求数据拦截
 */

instanceNoErr.interceptors.request.use(
  config => {
    // async (config) => {
    //     if (process.env.NODE_ENV === 'production' && !Vue.prototype.baseURL) {
    //       await axios.get('./config.json').then(e => {
    //         baseURL = e.data.baseURL
    //       })
    //     }
    //     Vue.prototype.baseURL = baseURL
    // config.baseURL = baseURL
    config.headers = {
      timestamp: parseInt(new Date().getTime() / 1000),
      version: '1.0.0',
      platform: 'WEIXIN',
      nonce: generateMixed(5)
    };
    if (help.getToken()) {
      config.headers['token'] = help.getToken();
    }
    const arr = [];
    Object.getOwnPropertyNames(config.headers).forEach((key) => {
      if (config.headers[key] == '[object Object]') {
        return;
      }
      arr.push(key + '=' + config.headers[key]);
    });
    config.headers['sign'] = md5(arr.sort().join('&') + '&secret=' + help.getSecret()).toLowerCase();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
/**
 * 响应数据拦截
 */

instanceNoErr.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code === 203) {
      help.delToken();
      location.reload();
    }
    return res;
  },
  error => {
    // Toast.fail({
    //   icon: 'warning',
    //   message: '网络错误',
    //   mask: true,
    //   className: 'newToast'
    // });
    return Promise.reject(error);
  }
);
